<template>
  <el-row>
    <el-col :span="16">
      <h1 class="logo">
        <i
          style="cursor: pointer; margin-right: 35px"
          class="text-contrast raw-icon el-icon-fa-bars"
          @click="toggleMenu"
        ></i>
        
        <router-link v-if="!isMobile" to="/">ITE DV7 </router-link>
      </h1>
    </el-col>
    <el-col v-if="isMobile" class="text-right" :span="8">
      <a href="javascript:" class="signout-link" @click="signout">
        <i title="Sign out" class="el-icon-fa-sign-out"/>
      </a>
    </el-col>


    <el-col class="text-right" :span="2">         
     <lang-select class="set-language"/>
    </el-col>


    <el-col v-if="!isMobile" class="text-right" :span="6">
      <el-dropdown @command="handleDropdownCommand">
        <span class="el-dropdown-link">
         {{ email }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="goToActivity">
            <i class="el-icon-fa-eye"></i> Activity Log
          </el-dropdown-item>
          <el-dropdown-item command="signout">
            <i class="el-icon-fa-sign-out"></i> Sign out
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LangSelect from '@/components/LangSelect'

export default {
  name: "app-header",
  components: {
    LangSelect
  },
  computed: {
    ...mapGetters({
      email: "auth/email",
      isMobile: "shared/isMobile"
    })
  },

  methods: {
    ...mapActions({
      toggleMenu: "shared/toggleMenu"
    }),

    handleDropdownCommand(command) {
      if (command === "goToActivity") {
        this.goToActivity();
      }

      if (command === "signout") {
        this.signout();
      }
    },

    goToActivity() {
      this.$router.push({ name: "activity" });
    },

    signout() {
      return this.$store.dispatch("auth/signout");
    }
  }
};
</script>

<style lang="scss" scoped>
.set-language {
    position: absolute;
    font-size:25px;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/shared/layout/header.vue?0befee3c